<div class="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm"
    @backdropAnimation (click)="onClose()">

    <!-- Modal Content -->
    <div class="bg-white dark:bg-slate-900 rounded-3xl shadow-2xl w-full max-w-md overflow-hidden flex flex-col relative border border-transparent dark:border-slate-800"
        @modalAnimation (click)="$event.stopPropagation()">

        <button (click)="onClose()"
            class="cursor-pointer absolute top-4 right-4 z-10 w-8 h-8 flex items-center justify-center rounded-full bg-black/10 hover:bg-black/20 text-white transition-colors">
            <span class="material-icons">close</span>
        </button>

        <!-- Loading -->
        <div *ngIf="isLoading" class="p-16 flex flex-col items-center justify-center text-slate-400 dark:text-slate-500">
            <span class="material-icons text-4xl mb-2 animate-spin">sync</span>
            <span class="text-sm font-medium">กำลังโหลดข้อมูลบัตร...</span>
        </div>

        <!-- Error -->
        <div *ngIf="!isLoading && error" class="p-10 flex flex-col items-center justify-center text-rose-500">
            <span class="material-icons text-4xl mb-2">error_outline</span>
            <span class="text-sm font-medium text-center">{{ error }}</span>
            <button *ngIf="siteId && cardName" type="button" (click)="retryLoad()"
                class="mt-4 px-4 py-2 bg-white dark:bg-slate-800 border border-rose-200 dark:border-rose-900 rounded-lg shadow-sm text-sm font-bold hover:bg-rose-50 dark:hover:bg-rose-900/30 transition-colors text-rose-600 dark:text-rose-400">
                ลองใหม่อีกครั้ง
            </button>
            <button type="button" (click)="onClose()"
                class="mt-3 px-4 py-2 text-sm font-bold text-slate-500 hover:text-slate-700 dark:hover:text-slate-300">
                ปิด
            </button>
        </div>

        <ng-container *ngIf="!isLoading && !error && memberData">
            <!-- Card Visual -->
            <div
                class="bg-[#ffe340] p-8 text-slate-800 h-64 flex flex-col justify-between relative overflow-hidden shadow-inner">
                <div class="absolute top-0 right-0 -mt-10 -mr-10 w-40 h-40 rounded-full bg-white/20 blur-xl"></div>
                <div class="absolute bottom-0 left-0 -mb-10 -ml-10 w-40 h-40 rounded-full bg-orange-500/10 blur-xl"></div>

                <div class="flex justify-between items-start relative z-10">
                    <div class="flex flex-col">
                        <span class="text-xs font-bold opacity-75 uppercase tracking-widest text-yellow-800">City
                            Parking</span>
                        <span class="text-[11px] font-semibold text-yellow-900/70 mt-0.5">{{ memberData.siteName || '-'
                            }}</span>
                    </div>
                </div>

                <div class="flex flex-col gap-1 relative z-10">
                    <span class="text-lg font-mono tracking-widest text-yellow-800 font-bold drop-shadow-sm">{{
                        memberData.cardCode || 'XXXX XXXX XXXX' }}</span>
                    <div class="flex justify-between items-end mt-2">
                        <div class="flex flex-col">
                            <span class="text-[10px] opacity-75 uppercase text-slate-800 font-semibold">Card Holder</span>
                            <span class="text-sm font-bold text-yellow-800">{{ displayHolderName }}</span>
                        </div>
                        <div class="flex flex-col items-end">
                            <span class="text-[10px] opacity-75 uppercase text-slate-800 font-semibold">Exp Date</span>
                            <span class="text-sm font-bold text-yellow-800">{{ (memberData.expireDate | date:'MM/yy') ||
                                '-' }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Details -->
            <div class="p-6 bg-white dark:bg-slate-900 overflow-y-auto max-h-[60vh] custom-scrollbar">
                <div class="flex items-center gap-4 mb-6">
                    <div
                        class="w-12 h-12 rounded-full bg-slate-100 dark:bg-slate-800 flex items-center justify-center text-slate-400">
                        <span class="material-icons">person</span>
                    </div>
                    <div>
                        <h3 class="font-bold text-slate-800 dark:text-white">ข้อมูลสมาชิก</h3>
                        <p class="text-xs text-slate-400">Member Details</p>
                    </div>
                </div>

                <div class="space-y-4">
                    <div class="flex justify-between py-2 border-b border-slate-50 dark:border-slate-800">
                        <span class="text-sm text-slate-500">ชื่อบัตร</span>
                        <span class="text-sm font-medium text-slate-800 dark:text-slate-200">{{ memberData.cardName ||
                            '-' }}</span>
                    </div>
                    <div class="flex justify-between py-2 border-b border-slate-50 dark:border-slate-800">
                        <span class="text-sm text-slate-500">ประเภทบัตร</span>
                        <span class="text-sm font-medium text-slate-800 dark:text-slate-200">{{ memberData.cardTypeName
                            || '-' }}</span>
                    </div>
                    <div class="flex justify-between py-2 border-b border-slate-50 dark:border-slate-800">
                        <span class="text-sm text-slate-500">วันออกบัตร</span>
                        <span class="text-sm font-medium text-slate-800 dark:text-slate-200">{{ (memberData.issueDate |
                            date:'dd/MM/yyyy') || '-' }}</span>
                    </div>
                    <div class="flex justify-between py-2 border-b border-slate-50 dark:border-slate-800">
                        <span class="text-sm text-slate-500">วันหมดอายุ</span>
                        <span class="text-sm font-medium text-slate-800 dark:text-slate-200">{{ (memberData.expireDate |
                            date:'dd/MM/yyyy') || '-' }}</span>
                    </div>
                    <div class="flex justify-between py-2 border-b border-slate-50 dark:border-slate-800">
                        <span class="text-sm text-slate-500">ชื่อลูกค้า</span>
                        <span class="text-sm font-medium text-slate-800 dark:text-slate-200">{{ memberData.clientName ||
                            '-' }}</span>
                    </div>
                    <div class="flex justify-between py-2 border-b border-slate-50 dark:border-slate-800">
                        <span class="text-sm text-slate-500">เบอร์โทรศัพท์</span>
                        <span class="text-sm font-medium text-slate-800 dark:text-slate-200">{{ memberData.phone || '-'
                            }}</span>
                    </div>
                    <div class="flex justify-between py-2 border-b border-slate-50 dark:border-slate-800">
                        <span class="text-sm text-slate-500">Subscription</span>
                        <span class="text-sm font-medium text-slate-800 dark:text-slate-200">{{
                            memberData.subscriptionName || '-' }}</span>
                    </div>
                </div>

                <!-- Renewal History -->
                <div class="mt-6" *ngIf="memberData.parkingRenewHistories?.length">
                    <h4 class="text-sm font-bold text-slate-800 dark:text-white mb-3 flex items-center gap-2">
                        <span class="material-icons text-slate-400 text-sm">history</span> ประวัติการต่ออายุ
                    </h4>
                    <div class="space-y-3">
                        <div *ngFor="let history of memberData.parkingRenewHistories"
                            class="bg-slate-50 dark:bg-slate-800/60 p-3 rounded-xl border border-slate-100 dark:border-slate-700">
                            <div class="flex justify-between items-center mb-1">
                                <span
                                    class="text-xs font-bold text-slate-800 bg-[#ffe340] px-2 py-0.5 rounded shadow-sm">{{
                                    history.receiptNo }}</span>
                                <span class="text-[10px] text-slate-400">{{ history.startDate | date:'dd/MM/yy' }} - {{
                                    history.expireDate | date:'dd/MM/yy' }}</span>
                            </div>
                            <div class="flex justify-between items-center">
                                <span class="text-xs text-slate-500">ยอดชำระ</span>
                                <span class="text-sm font-bold text-slate-800 dark:text-slate-200">{{ history.price |
                                    number:'1.2-2' }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <button (click)="onClose()"
                    class="w-full mt-6 py-3 bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 rounded-xl font-bold hover:bg-slate-200 dark:hover:bg-slate-700 transition-colors">
                    ปิดหน้าต่าง
                </button>
            </div>
        </ng-container>

    </div>
</div>
